import chromeIcon from '#/assets/browsers/chrome.png'
import edgeIcon from '#/assets/browsers/edge.png'
import firefoxIcon from '#/assets/browsers/firefox.png'
import operaIcon from '#/assets/browsers/opera.png'
import safariIcon from '#/assets/browsers/safari.png'
import { SupportedBrowser } from '#/store/services/BrowserGuard/types'

export const SUPPORTED_BROWSERS: readonly SupportedBrowser[] = [
  {
    icon: chromeIcon,
    key: 'chrome',
    label: 'Chrome',
    url: 'https://www.google.com/chrome/',
  },
  {
    icon: edgeIcon,
    key: 'edge',
    label: 'Edge',
    url: 'https://www.microsoft.com/edge',
  },
  {
    icon: firefoxIcon,
    key: 'firefox',
    label: 'Firefox',
    url: 'https://www.mozilla.org/firefox/new/',
  },
  {
    icon: operaIcon,
    key: 'opera',
    label: 'Opera',
    url: 'https://www.opera.com/download',
  },
  {
    icon: safariIcon,
    key: 'safari',
    label: 'Safari',
    url: 'https://support.apple.com/pt-br/102665',
  },
]

export const SAFARI_BROWSER: SupportedBrowser = SUPPORTED_BROWSERS.find(
  browser => browser.key === 'safari',
)!
